import type { RouteResources } from '@atlassian/react-resource-router';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { getNavigationSidebarProductsSettingResource } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsProductsAccessRoute } from '@jira/router-routes__legacy-global-settings-products-access-routes/src/globalSettingsProductsAccessRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsProductsAccessRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsProductsAccessRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: getNavigationSidebarProductsSettingResource(),
		entryPoint: () => pageEntryPoint,
	}));
